import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import {
  OrderIntakeReviewField,
  OrderIntakeReviewReason,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { RowItemLabelValue } from '~components/Job/RowItemLabelValue';
import { IntakeReviewItem } from '~hooks/useOrders/models';
import isEnumValue from '~utils/isEnumValue';

const intakeReviewFieldLabelKey = {
  [OrderIntakeReviewField.DROPOFF_SITE]: 'form_fields.dropoff',
  [OrderIntakeReviewField.EQUIPMENT_TYPE]: 'form_fields.equipment_type',
  [OrderIntakeReviewField.LOAD_AT]: 'dispatch.order.service_date_and_time',
  [OrderIntakeReviewField.MATERIAL]: 'form_fields.material',
  [OrderIntakeReviewField.PICKUP_SITE]: 'form_fields.pickup',
  [OrderIntakeReviewField.QUANTITY]: 'form_fields.quantity',
  [OrderIntakeReviewField.TRUCK_COUNT]: 'form_fields.number_of_trucks',
} satisfies Record<OrderIntakeReviewField, string>;

const intakeReviewReasonLabelKey = {
  [OrderIntakeReviewReason.LOW_CONFIDENCE]:
    'dispatch.order.intake_review.reasons.low_confidence',
  [OrderIntakeReviewReason.UNMATCHED]: 'dispatch.order.intake_review.reasons.unmatched',
} satisfies Record<OrderIntakeReviewReason, string>;

interface IntakeReviewItemsProps {
  reviewItems: IntakeReviewItem[];
}

export default function IntakeReviewItems({ reviewItems }: IntakeReviewItemsProps) {
  if (!reviewItems.length) {
    return null;
  }

  return (
    <>
      <Typography variant="group-title">
        {t('dispatch.order.intake_review.title')}
      </Typography>
      <Table>
        <TableBody>
          {reviewItems.map((reviewItem, index) => {
            const isLastReviewItem = index === reviewItems.length - 1;
            const fieldLabel = isEnumValue(OrderIntakeReviewField, reviewItem.field)
              ? t(intakeReviewFieldLabelKey[reviewItem.field])
              : reviewItem.field;
            const reasonLabel = isEnumValue(OrderIntakeReviewReason, reviewItem.reason)
              ? t(intakeReviewReasonLabelKey[reviewItem.reason])
              : reviewItem.reason;

            return (
              <RowItemLabelValue
                key={`${reviewItem.field}-${index}`}
                label={fieldLabel}
                sx={isLastReviewItem ? { borderBottomColor: 'transparent' } : undefined}
                value={t('dispatch.order.intake_review.item', {
                  interpolation: { escapeValue: false },
                  reason: reasonLabel,
                  text: reviewItem.text,
                })}
              />
            );
          })}
        </TableBody>
      </Table>
    </>
  );
}
